import styled from '@emotion/styled';
import vars from '@variables';
import { H2Atom, PAtom } from '@atoms/text-atoms/text-atoms';
import { sectionTitleBorder } from '../../mixins';

interface ImageBlockContainerProps {
  anchorId?: string;
  colour?: string;
  images?: any[];
  narrowWidth?: boolean;
}

export const RichTextEntryImageBlockContainer = styled.div`
  img {
    float: inherit;
    margin: 0;
  }

  ${H2Atom} {
    padding-left: 0 !important;
    margin-left: 0 !important;
    border: none !important;
  }
`;

export const ImageBlockContainer = styled.div<ImageBlockContainerProps>`
  margin-top: ${({ anchorId }) => (anchorId ? vars.spacingL : '0px')};
  background-color: white;
  margin: 3.2rem auto;
  text-align: left;
  ${vars.fontSize8}
  overflow-x: auto;
  max-width: ${({ narrowWidth }) => (narrowWidth ? '66.66%' : '100%')};

  ${H2Atom} {
    ${({ colour }) => sectionTitleBorder(colour)}
    margin-top: ${vars.spacingM};
    @media screen and (min-width: ${vars.breakPointTenColumn}) {
      margin-top: ${vars.spacingL};
    }
  }

  .gatsby-image-pos > div {
    max-width: inherit !important; // Horrible hack to override gatsby image plugins max-width css.
  }

  .content-container {
    display: flex;
    width: ${({ images }) =>
      images && images.length > 1
        ? vars.doubleImageContentContainerPercentageWidth
        : '100%'};
    justify-content: space-between;
    margin-top: ${vars.spacingM};
    .image-with-caption-wrapper {
      .gatsby-image-wrapper {
        width: 100%;
      }
      width: ${({ images }) =>
        images && images.length > 1 ? vars.mobileImagePercentageWidth : '100%'};
      img {
        width: 100%;
        border-radius: 8px;
      }
      ${PAtom} {
        max-width: 80%;
        margin: 0;
        ${vars.fontSize2}
        padding: ${vars.spacingS} 2rem 0 0;
      }
      a {
        display: block;
        text-decoration: none;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  @media screen and (min-width: ${vars.breakPointTenColumn}) {
    .content-container {
      width: 100%;
      .image-with-caption-wrapper {
        width: ${({ images }) =>
          images && images.length > 1
            ? vars.standardDoubleImagePercentageWidth
            : '100%'};
        img {
          width: 100%;
        }
      }
    }
  }

  @media screen and (max-width: ${vars.breakPointTablet}) {
    max-width: 100%;
  }
`;
